
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Home } from "./components/Home/Home";
import { SingleProduct } from "./components/SingleProduct/SingleProduct";
import { Newsletter } from "./components/Footer/Newsletter/Newsletter";
import { AppContext } from "./utils/context";
import { Footer } from "./components/Footer/Footer";
import { Header } from "./components/Header/Header";
import Category from "./components/Category/Category";




function App(){
  return(
    <BrowserRouter>
    <AppContext>
     <Header />
    <Routes>
      <Route path="/" element={<Home />} />
      {/* <Route path="/category" element={<Category />} /> */}
      <Route path="/category/:id" element={<Category />} />
      <Route path="/product/:id" element={<SingleProduct />} />
    </Routes>
    <Newsletter />
   <Footer />
    </AppContext>
    </BrowserRouter>
  )
}

export default App;